import React from "react";
import { Container, Box, makeStyles, Grid, Divider,useMediaQuery,useTheme } from "@material-ui/core";
import Logo from "../assets/images/logo.PNG";
import { useHistory } from "react-router-dom";
import SlideDownModal from "../components/reusableComponents/SlideDownModal";
import Footer from "./Desktop/Footer";
import SearchEngine from "../form/SearchEngine";
import HeaderSection from "../components/reusableComponents/HeaderSection";
import { useSelector } from "react-redux";
const useStyles = makeStyles(() => ({
  item: {
    //   backgroundColor: "#ee8622",
    display: "flex",
    listStyle: "none",
    marginBottom: 0,
    marginTop: 0,
    "&:hover": {
      backgroundColor: "#ee8622",
    },
  },
  li: {
    color: "white",
    padding: "4px 8px",
    background: "no-repeat",
    borderRight: "none",
  },
  card: {
    padding: 30,
    background:'rgba(62, 29, 28, 0.9)',
    "&:hover": {
      // backgroundColor: "#ee8622",
      boxShadow: "rgb(149 157 165 / 20%) 0px 8px 24px",
    },
  },
}));
const HotDeals = () => {
  const classes = useStyles();
  const history = useHistory();
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));
  const {sector} = useSelector((state)=>state.user)
  const [header, SetHeader] = React.useState("onlineRecharge");

  const handleClickOpen = (item) => {
    // setOpen(true);
    let formData = {
      AdultCount: 1,
      ChildCount: 0,
      InfantCount: 0,
      DirectFlight: false,
      OneStopFlight: false,
      JourneyType: 1,
      PreferredAirlines: null,
      Segments: [
        {
          Origin: item.origin,
          Destination: item.destination,
          FlightCabinClass: 1,
          PreferredDepartureTime: item.departureDate,
        },
      ],
      Sources: "WEB",
      agent_id: 0,
    };
    console.log('data',formData)
    history.push({
      pathname: "/search",
      state: {
        body: formData,
        OriginO: item.departureDate,
      },
    });
    console.log("item",item)
  };

  const handleClose = () => {
    setOpen(false);
  };
  let originsector = [];
  let destinationsector = [];
  let destinationsectorUnique = [];
  if (sector?.status === 200 && sector?.result.length > 0) {
    originsector = [
      ...new Set(
        sector &&
          sector?.result &&
          sector?.result.length > 0 &&
          sector?.result.map((item) => item.origin)
      ),
    ];
  }
  if (sector?.status === 200 && sector?.result.length > 0) {
    sector &&
      sector?.result &&
      sector?.result.length > 0 &&
      sector.result.map((i) => {
        if (i.origin === 'DEL')
          destinationsector.push({
            ...i,
          });
      });
  }
  if (destinationsector && destinationsector?.length > 0) {
    destinationsectorUnique = [
      ...new Set(
        destinationsector &&
          destinationsector.length > 0 &&
          destinationsector.map((item) => item.destination)
      ),
    ];
  }
  console.log("sector", originsector);
  console.log("destinationsector", destinationsector);
  console.log("destinationsectorUnique", destinationsectorUnique);
  const handelHeader = (val) => {
    SetHeader(val);
  };
  return (
    <div>
    <HeaderSection/>
    <Divider style={{background:'#0f3f5a'}}/>
      <Container style={{ paddingLeft:matches?10: 50, paddingRight:matches?10: 50, paddingTop: 50 }}>
        <p
          style={{
            textAlign: "center",
            color: "rgb(15, 63, 90)",
            fontSize: 30,
            fontWeight: "bold",
          }}
        >
          Hot Deals
        </p>
        {originsector.map((i)=>{
            return (
                <>
                 <Box style={{marginTop:30}}>
                <span style={{color:'#343a40',fontSize:26,fontWeight:'bold'}}>{i}</span>
            </Box>
        <Grid container spacing={2}>
          { sector &&
      sector?.result &&
      sector?.result.length > 0 &&
      sector.result.map((item)=>{
        return   i===item.origin?<Grid item xs={6} lg={3}> 
        <Box
          onClick={()=>handleClickOpen(item)}
          className={classes.card}
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: 40,
            cursor: "pointer",
            borderRadius: 5,
            justifyContent:'center'
          }}
        >
          {i===item.origin?
            <span style={{color:'white',fontWeight:'bold',textAlign:'center'}}>{i}-{i===item.origin?item.destination:''}</span>:''
          }
        </Box>
      </Grid>:''
      })}
          {/* {Array.from(Array(6)).map((i) => {
            return (
              <Grid item xs={6} lg={3}> 
                <Box
                  onClick={handleClickOpen}
                  className={classes.card}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: 40,
                    cursor: "pointer",
                    borderRadius: 5,
                    justifyContent:'center'
                  }}
                >
                    <span style={{color:'white',fontWeight:'bold',textAlign:'center'}}>DEL-CCU</span>
                </Box>
              </Grid>
            );
          })} */}
        </Grid>
        <Divider style={{background:'#0f3f5a',marginTop:20}}/>
                </>
            )
        })}
       
      </Container>
      {/* <SlideDownModal
        open={open}
        handleClickOpen={handleClickOpen}
        handleClose={handleClose}
      /> */}
      <Footer />
    </div>
  );
};

export default HotDeals;
